import type { DocumentsSummaryResult } from "@/modules/quotation-invoice/domain/types";

export type DocumentsCountSummary = {
  quotationCount: number;
  invoiceCount: number;
  receiptCount: number;
  totalDocuments: number;
};

export function computeDocumentsCountSummary(
  data: DocumentsSummaryResult | undefined,
): DocumentsCountSummary {
  const blocks = data?.byCurrency ?? [];

  const quotationCount = blocks.reduce(
    (sum, row) => sum + row.totalQuotationsCount,
    0,
  );
  const invoiceCount = blocks.reduce(
    (sum, row) => sum + row.pendingInvoicesCount,
    0,
  );
  const receiptCount = blocks.reduce(
    (sum, row) => sum + row.paidReceiptsCount,
    0,
  );

  return {
    quotationCount,
    invoiceCount,
    receiptCount,
    totalDocuments: quotationCount + invoiceCount + receiptCount,
  };
}
